import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {Router} from '@angular/router';
import {resetPageNotFound, setPageNotFound, setRedirectUrl} from '@app/page-not-found/state/page-not-found.actions';
import {Store} from '@ngrx/store';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { Bind } from 'primeng/bind';
import { Button } from 'primeng/button';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    imports: [
        Bind,
        Button,
        TranslatePipe,
    ],
})
export class PageNotFoundComponent implements OnInit, OnDestroy {
  private readonly translate = inject(TranslateService);
  private readonly store = inject(Store);
  private readonly router = inject(Router);


  ngOnInit(): void {
    this.store.dispatch(setPageNotFound());
  }

  navigateToMyOrders(): void {
    this.router.navigate(['/my-orders']);
    this.store.dispatch(setRedirectUrl({redirectUrl: '/my-orders'}));
  }

  navigateToTests(): void {
    this.router.navigate(['/category']);
    this.store.dispatch(setRedirectUrl({redirectUrl: '/category'}));
  }

  ngOnDestroy(): void {
    this.store.dispatch(resetPageNotFound());
  }
}
